import { Box, Theme, Typography } from "@mui/material";
import useIsMobileView from "../../utils/hooks/useIsMobileView";
import { TestTimerVariables } from "../../types/test-types";

const TestWordSlide = (props: { variables: TestTimerVariables }) => {
  const isMobileView = useIsMobileView();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Box component="main">
        <Typography
          color="primary"
          variant="h1"
          sx={(theme) => ({
            color: "#385723",
            userSelect: "none",
            ...styles.center,
            ...fadingEffect(props.variables.showBlankPage),
            ...fontSizes(theme),
          })}
        >
          {props.variables.word}
        </Typography>
      </Box>

      <Box
        component="footer"
        sx={{
          marginTop: "auto",
          marginRight: isMobileView ? 2 : 4,
          marginBottom: isMobileView ? 2 : 4,
        }}
      >
        <Typography
          color="primary"
          align="right"
          variant={isMobileView ? "h2" : "h1"}
          sx={{ color: "#c8c8c8", userSelect: "none" }}
        >
          {props.variables.index > 0 ? String(props.variables.index).padStart(2, "0") : "00"}
        </Typography>
      </Box>
    </Box>
  );
};

const styles = {
  fadeIn: {
    transition: "opacity 0.5s ease",
  },
  fadeOut: {
    opacity: 0,
    transition: "opacity 0.5s ease",
  },
  center: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
};

const fadingEffect = (trigger: boolean) => {
  return trigger ? styles.fadeOut : styles.fadeIn;
};

const fontSizes = (theme: Theme) => ({
  [theme.breakpoints.up("xs")]: {
    fontSize: "70px",
  },
  [theme.breakpoints.up("sm")]: {
    fontSize: "120px",
  },
  [theme.breakpoints.up("md")]: {
    fontSize: "160px",
  },
  [theme.breakpoints.up("lg")]: {
    fontSize: "200px",
  },
  [theme.breakpoints.up("xl")]: {
    fontSize: "240px",
  },
});

export default TestWordSlide;
